
export class ViewportUtil {
    #siteViewportRules;
    #originalViewportRules;
    #resourcesService;

    get #metaViewPortElement() {
        return document.head.querySelector('[name=viewport]');
    }

    constructor() {
        const siteViewport = this.#metaViewPortElement?.content;
        this.#siteViewportRules = this.#parseViewportStringToRules(siteViewport);
        this.#originalViewportRules = Object.freeze({ ...this.#siteViewportRules });
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
    }

    update() {
        this.#setViewportFitCover().#setDeviceWidth().#setInitialScale().#setMaxScale().#applyRules();
    }

    reset() {
        console.info('Resetting viewport rules');
        if (this.#originalViewportRules) {
            this.#siteViewportRules = { ...this.#originalViewportRules };
            this.#applyRules();
        }
    }

    #setViewportFitCover() {
        if (this.#siteViewportRules && !this.#siteViewportRules['viewport-fit']) {
            if (!this.#allowAttribute('FIT_COVER')) {
                console.info('Ability to override viewport fit is disabled');
                return this;
            }
            console.info('No viewport-fit rule found; adding one');
            this.#siteViewportRules['viewport-fit'] = 'cover';
        }
        return this;
    }

    #setDeviceWidth() {
        if (this.#siteViewportRules && !this.#siteViewportRules['width']) {
            if (!this.#allowAttribute('DEVICE_WIDTH')) {
                console.info('Ability to override viewport width is disabled');
                return this;
            }
            console.info('No width rule found; adding "width=device-width"');
            this.#siteViewportRules['width'] = 'device-width';
        }
        return this;
    }

    #setInitialScale() {
        if (this.#siteViewportRules && !this.#siteViewportRules['initial-scale']) {
            if (!this.#allowAttribute('INITIAL_SCALE')) {
                console.info('Ability to override viewport initial scale is disabled');
                return this;
            }
            console.info('No initial-scale rule found; adding one');
            this.#siteViewportRules['initial-scale'] = '1.0';
        }
        return this;
    }

    #setMaxScale() {
        if (this.#siteViewportRules && !this.#siteViewportRules['maximum-scale']) {
            if (!this.#allowAttribute('MAXIMUM_SCALE')) {
                console.info('Ability to override viewport max scale is disabled');
                return this;
            }
            this.#siteViewportRules['maximum-scale'] = '1.0';
        }
        return this;
    }

    #allowAttribute(attributeName) {
        const resource = this.#resourcesService.getResource(`SELFSCHEDULER_ALLOW_VIEWPORT_${attributeName}`, '1');
        return resource === '1';
    }

    #parseViewportStringToRules(rule) {
        const viewportRules = {};
        if (!rule) {
            return viewportRules;
        }
        rule.split(',').forEach(segment => {
            const trimmed = segment.trim();
            const [key, value] = trimmed.split('=');
            if (key && value) {
                viewportRules[key.toLowerCase()] = value.trim();
            }
        });
        return viewportRules;
    }

    #buildRuleString(viewportRules) {
        return Object.entries(viewportRules)
            .map(([k, v]) => `${k}=${v}`)
            .join(', ');
    }

    #applyRules() {
        if (this.#siteViewportRules) {
            this.#removeViewportMeta();
            const ruleString = this.#buildRuleString(this.#siteViewportRules);
            if (ruleString) {
                this.#addMetaData('viewport', ruleString);
            }
        }
        return this;
    }

    #addMetaData(name, content) {
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        document.head.appendChild(meta);
    }

    #removeViewportMeta() {
        const meta = this.#metaViewPortElement;
        if (meta) {
            meta.remove();
        }
    }
}

